import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pickup-branches")({
  component: lazyRouteComponent(() => import("./-pages/admin.pickup-branches")),
  head: () => ({
    meta: [{ title: "فروع الاستلام — Lecmo Admin" }],
  }),
});
